import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white relative overflow-hidden">
      {/* 배경 장식 */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 메인 푸터 콘텐츠 */}
        <div className="py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* 좌측 브랜드 영역 */}
            <div className="space-y-6">
              <div className="flex items-center space-x-2">
                <img 
                  src="https://static.readdy.ai/image/337fc9296261a6caddd83b9535d8de1f/40dca02990e3f529dd8487d157a79046.png" 
                  alt="퀀텀하이 로고" 
                  className="h-10 w-auto"
                />
                <span className="text-2xl font-bold">퀀텀하이</span>
                <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
              </div>
              
              {/* 이메일 구독 */}
              <div className="flex max-w-md">
                <input
                  type="email"
                  placeholder="이메일 주소를 입력하세요"
                  className="flex-1 px-4 py-2 bg-transparent border border-white/30 rounded-l-full text-white placeholder-white/60 focus:outline-none focus:border-orange-500"
                />
                <button className="px-4 py-2 bg-orange-500 text-white rounded-r-full hover:bg-orange-600 transition-colors">
                  <i className="ri-notification-line"></i>
                </button>
              </div>

              <div className="space-y-2">
                <h3 className="text-2xl font-serif leading-relaxed">
                  한국과 일본을 잇는<br />
                  비즈니스 파트너
                </h3>
              </div>
            </div>

            {/* 우측 링크 영역 */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div>
                <h4 className="font-semibold mb-4">Services</h4>
                <ul className="space-y-2 text-sm text-white/80">
                  <li><Link to="/services" className="hover:text-orange-500 transition-colors">Trade</Link></li>
                  <li><Link to="/services" className="hover:text-orange-500 transition-colors">Education</Link></li>
                  <li><Link to="/services" className="hover:text-orange-500 transition-colors">Contents</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Company</h4>
                <ul className="space-y-2 text-sm text-white/80">
                  <li><Link to="/about" className="hover:text-orange-500 transition-colors">About Us</Link></li>
                  <li><Link to="/about" className="hover:text-orange-500 transition-colors">Team</Link></li>
                  <li><Link to="/recruitment" className="hover:text-orange-500 transition-colors">Careers</Link></li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Resources</h4>
                <ul className="space-y-2 text-sm text-white/80">
                  <li><a href="#" className="hover:text-orange-500 transition-colors">Blog</a></li>
                  <li><a href="#" className="hover:text-orange-500 transition-colors">Case Studies</a></li>
                  <li><a href="#" className="hover:text-orange-500 transition-colors">FAQ</a></li>
                </ul>
              </div>

              <div>
                <h4 className="font-semibold mb-4">Contact</h4>
                <ul className="space-y-2 text-sm text-white/80">
                  <li><a href="mailto:quantumhigh@naver.com" className="hover:text-orange-500 transition-colors">Email</a></li>
                  <li><a href="tel:+82-51-205-0950" className="hover:text-orange-500 transition-colors">Phone</a></li>
                  <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Location</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* 하단 영역 */}
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-white/60">
              © 2025 QuantumHi. All rights reserved.
            </p>

            {/* 소셜 미디어 아이콘 */}
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors">
                <i className="ri-youtube-line"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors">
                <i className="ri-facebook-line"></i>
              </a>
            </div>

            <div className="flex items-center space-x-4 text-sm text-white/60">
              <a href="#" className="hover:text-orange-500 transition-colors">Privacy Policy</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}